import { Path } from '@/main/router/routerPath';

import Edit from './Edit.vue';
import List from './List.vue';
import { NAME, CRUMB_LABEL_KEY } from './constants';

export const router = new Path(NAME, { List, Edit }, CRUMB_LABEL_KEY);
